import Vue from 'vue';
const initialFilter = {
  reason: '',
  PhoneId: null,
  fromDate: null,
  toDate: null,
};
export default {
  data() {
    return {
      searchTitle: '',
      tableHeaders: [
        {
          text: 'کد',
          value: 'phoneCode',
        },
        {
          text: 'تاریخ شروع',
          value: 'startDate',
        },
        {
          text: 'تاریخ پایان',
          value: 'endDate',
        },
        {
          text: 'علت',
          value: 'reason',
        },
        {
          text: 'جزییات',
          value: 'reasonDetail',
        },
      ],
      hasSearch: false,
      filterData: initialFilter,
      isFilterModalOpen: false,
      isDetailModalOpen: false,
      detailId: null,
      pagination: {
        pageNumber: 1,
        pageSize: 10,
        totalItems: 0,
      },
    };
  },
  computed: {
    hasSearch: function () {
      return Object.values(this.filterData)?.some((value) => !!value);
    },
  },
  mounted() {
    this.mounteLoding();
  },
  methods: {
    mounte: function () {
      this.getGroundingList();
      this.getAllPhones();
    },
    transformGroundingList: function (groundingList) {
      return [...groundingList]?.map((item) => ({
        id: item?.id,
        reason: item?.reason ?? '-',
        reasonDetail: item?.reasonDetail ?? '-',
        startDate: item?.phoneActivity?.startDate
          ? Vue.moment(item?.phoneActivity?.startDate).format('jYYYY/jMM/jDD-hh:mm:ss')
          : '-',
        endDate: item?.phoneActivity?.endDate
          ? Vue.moment(item?.phoneActivity?.endDate).format('jYYYY/jMM/jDD-hh:mm:ss')
          : '-',
        phoneCode: item?.phoneActivity?.phone?.code ?? '-',
      }));
    },
    openFilterModal: function () {
      this.isFilterModalOpen = true;
    },
    closeFilterModal: function () {
      this.isFilterModalOpen = false;
    },
    openDetailModal: function (id) {
      this.detailId = id;
      this.isDetailModalOpen = true;
    },
    closeDetailModal: function () {
      this.isDetailModalOpen = false;
      this.detailId = null;
    },
    setPagination: function (data) {
      this.pagination.totalItems = data?.totalItems;
    },
    resetPageNumber: function () {
      this.pagination.pageNumber = 1;
    },
    onGettingList: function () {
      const params = {
        ...this.filterData,
        ...this.pagination,
      };
      this.getGroundingList(params);
    },
    setFilter: function (filterData) {
      this.resetPageNumber();
      this.filterData = filterData;
      this.onGettingList();
      this.closeFilterModal();
    },
    clearFilter: function () {
      this.filterData = initialFilter;
    },
  },
};
